module.exports = __webpack_public_path__ + "static/Office365-704f36e2bff28f5105de1a5f4ace33ed.png";